module.exports = __webpack_public_path__ + "img/product1.14dc7d0.png";